// @ts-nocheck
import { Session, updateSession } from "@insite/client-framework/Services/SessionService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    customerCatalogId: string;
}

type HandlerType = Handler<Parameter>;

export const UpdateSession: HandlerType = async props => {
    await updateSession({
        session: {
            properties: {
                customerCatalogId: props.parameter.customerCatalogId.toString(),
            } as { [key: string]: string },
        } as Session,
    });
};

export const DispatchSetCustomerCatalog: HandlerType = props => {
    props.dispatch({
        type: "Context/SetCustomerCatalog",
        customerCatalogId: props.parameter.customerCatalogId,
    });
};

export const ReloadPage: HandlerType = () => {
    window.location.reload();
};

export const chain = [UpdateSession, DispatchSetCustomerCatalog, ReloadPage];

const setCustomerCatalog = createHandlerChainRunner(chain, "setCustomerCatalog");
export default setCustomerCatalog;
